import {management} from '../../../..'

import { GetManagementByIdSectorUseCase } from "./getManagementByIdSector";

import {ManagementRepository} from '../../../infra/knex/repositories/management'

export const getManagementByIdSector=()=>{
  const repository=new ManagementRepository(management)

  const getManagementById= new GetManagementByIdSectorUseCase(repository)

  return getManagementById
}
